import React from 'react';

import WorldMap, { SizedWorldMap } from 'components/WorldMap';

export default function CountryGraphicContainer({ data }) {
  return (
    <>
      <SizedWorldMap data={data} />
    </>
  );
}
